import RailsApi from '../../../shared/utils/rails_api.js'

import { refreshMetaData } from './rails.js'
import { setErrorFlash, setSuccessFlash, updateSucceeded, updateFailed, updateStarted } from './wizard.js'

const LOAD   = "event_form/event/LOAD"
const UPDATE = "event_form/event/UPDATE"
const UPDATE_EMAILS = "event_form/eventEmail/UPDATE"

export default function event(state = {}, action) {
  switch (action.type) {
    case LOAD: {
      return { ...action.event }
    }

    case UPDATE: {
      return { ...state, ...action.attributes }
    }

    default: {
      return state
    }
  }
}

export const loadEvent = (event) => {
  return { type: LOAD, event: event }
}

export const updateEvent = (event) => {
  const { ...attributes } = event

  return { type: UPDATE, attributes: attributes }
}

export const updateEventEmail = (eventEmail) => {
  const { ...attributes } = eventEmail

  return { type: UPDATE_EMAILS, attributes: attributes }
}

export const asyncUpdateEvent = (url, data, updated) => (dispatch) => {
  dispatch(updateStarted())

  RailsApi.patch(url, { body: data }).
    then((json) => {
      dispatch({
        type: 'RAILS_UPDATE_SUCCEEDED',
        actions: [
          refreshMetaData({ ...json.meta }),
          updateEvent(json.event),
          updateEventEmail(json.eventEmail),
          updateSucceeded(),
          setSuccessFlash("Event Updated", { keep: updated })
        ]
      })
    }).
    catch((json) => {
      console.log("event error json: ", json);
      dispatch({
        type: 'RAILS_UPDATE_FAILED',
        actions: [
          updateFailed(),
          setErrorFlash(json.error.message, { details: json.error.details })
        ]
      })
    })
}
